import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  itemSku: {
    id: 'YVi6+D',
    description: 'Sku prefix before actual item sku',
    defaultMessage: 'SKU: {sku}',
  },
  modalTitle: {
    id: 'VMh2fF',
    description: 'Title of the serial number capture modal',
    defaultMessage: 'Serial Number Required',
  },
  modalHeading: {
    id: 'QvUaYJ',
    description: 'Heading inside the serial number modal',
    defaultMessage: 'Enter serial number',
  },
  modalInstruction: {
    id: 'B1BAzs',
    description: 'Instruction text in the serial number modal',
    defaultMessage: 'Scan or type a serial number for each unit.',
  },
  productQuantity: {
    id: '4fe/he',
    description: 'Quantity label on the product card in the serial number modal',
    defaultMessage: 'Qty:',
  },
  unitLabel: {
    id: 'mVhH8b',
    description: 'Label for a per-unit serial number input',
    defaultMessage: 'Serial Number - Unit {unit}',
  },
  inputPlaceholder: {
    id: 'w6GMWU',
    description: 'Placeholder for a serial number input',
    defaultMessage: 'Scan barcode or enter number',
  },
  save: {
    id: 'cEsCxJ',
    description: 'Button to save the entered serial numbers',
    defaultMessage: 'Save',
  },
  saveError: {
    id: 'RRybwQ',
    description: 'Error notification when saving serial numbers fails',
    defaultMessage: 'Failed to save serial numbers',
  },
  saveDuplicateError: {
    id: 'gmxGCc',
    description:
      'Error notification when saving serial numbers fails because a serial number is already assigned to the current order. Optionally shows list of duplicate serial numbers.',
    defaultMessage: 'One or more serial numbers are already used in this order{duplicates, select, undefined {} other {: {duplicates}}}',
  },
  loadError: {
    id: 'LbrsrL',
    description: 'Error notification when loading serial numbers fails',
    defaultMessage: 'Failed to load serial numbers',
  },
  serialNumbersMissing: {
    id: 'ZhSwPw',
    description: 'Inline warning showing how many serial numbers are still missing for an order item',
    defaultMessage: '{missing} of {total} serial numbers missing',
  },
  serialNumberRequiredStatus: {
    id: 'whofZ+',
    description: 'Inline status on a scan-page item row showing serial-number capture progress',
    defaultMessage: 'Serial number required - {entered} of {total} entered',
  },
  serialNumberLabel: {
    id: '2jdyTe',
    description: 'Inline label for a captured serial number row when the item has a single unit',
    defaultMessage: '<b>S/N:</b> {serialNumber}',
  },
  serialNumberIndexedLabel: {
    id: '+kybhg',
    description: 'Inline label for a captured serial number row when the item has multiple units',
    defaultMessage: '<b>S/N {unit}:</b> {serialNumber}',
  },
  edit: {
    id: 'pQIF7A',
    description: 'Link to edit captured serial numbers for an order item',
    defaultMessage: 'Edit',
  },
  multipleSerialNumbers: {
    id: 'IkmDwE',
    description: 'Expandable header that shows/hides the captured serial number list when clicked',
    defaultMessage: '{count, plural, one {# Serial Number} other {# Serial Numbers}}',
  },
  scanModalBanner: {
    id: 'AjQlNY',
    description: 'Informational banner in the scan-page sequential modal explaining that each unit needs its own serial',
    defaultMessage:
      'This order includes {count, plural, one {# unit} other {# units}} of this product. Each unit requires a unique serial number.',
  },
  scanModalCapturedSerial: {
    id: '82x8Tl',
    description: 'Label for a previously-captured serial shown above the active input in the scan sequential modal',
    defaultMessage: 'S/N {unit}: {serialNumber}',
  },
});
